<template>
  <div class="eficiencia-tecnica">
    <div class="title mb-3">
      <div class="d-flex justify-content-between">
        <p class="dark-0 p-16-custom">
          EFICIÊNCIA TÉCNICA
        </p>
        <p></p>
      </div>
      <div class="span-card"></div>
    </div>
    <div class="custon-grid">
      <b-table
        class="backbeat-table"
        :fields="fields"
        :items="this.$props.items"
        v-show="!this.$props.loading"
        responsive
        show-empty
        empty-text="Nenhuma informação para exibir!"
      >
        <template #cell(indicator)="data">
          {{ data.item.indicator }}
        </template>
        <template #cell(reachedGoal)="data">
          <div
            class="custom-row-table d-flex justify-content-center align-items-center"
          >
            <div
            :class="data.item.reachedGoal === 'Sim' ? ' custom-icon-check ' : ' custom-icon-no-check '"
              class="mt-4 justify-content-center align-items-center"
            ></div>
          </div>
        </template>
        <template #cell(resultSpecialty)="data">
          {{ data.item.resultSpecialty }}
        </template>
        <template #cell(resultIndividual)="data">
          {{ data.item.resultIndividual }}
        </template>
      </b-table>
      <div v-show="this.$props.loading">
        <b-skeleton-table :rows="12" :columns="4"></b-skeleton-table>
      </div>
    </div>
    <div class="eficiencia-tecnica-footer">
      <div class="custom-align-footer">
        <p
          class="p2 primary custom-pointer"
          @click="onActioHandler('IT', 'Eficiência Técnica')"
        >
          <img
            class="img-learn-more mr-2"
            src="../../../../assets/images/MDI-information-new.svg"
          />
            Entenda este indicador
        </p>
      </div>      
      <div class="custom-align-footer">
        <p
          class="text-right p-16-custom color-green-2 w-100"
        >{{ this.onGetAdicional() }}</p>
      </div>      
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "additionalGainTechnicalEfficiency",
    "items",
    "onAction",
    "loading"
  ],
  setup(props) {
    const onActioHandler = function(type, title) {
      props.onAction(type, title);
    };

    return { onActioHandler };
  },
  mounted() {
  },
  data() {
    return {
      fields: [
        {
          key: "indicator",
          label: "Nome do indicador",
          thStyle: { width: "50%", 'min-width': "249px"},
        },
        {
          key: "reachedGoal",
          label: "Atingiu a meta?",
          class: "text-center",
          thStyle: { width: "11%", 'min-width': "104px"},
        },
        {
          key: "resultSpecialty",
          label: "Resultado especialidade",
          class: "text-right",
          thStyle: { width: "25%", 'min-width': "153px" },
        },
        {
          key: "resultIndividual",
          label: "Resultado individual",
          class: "text-right",
          thStyle: { width:"14%", 'min-width': "132px"},
        }
      ]
    }
  },
  components: {},
  methods: {
    onGetAdicional() {
      return "Ganho adicional " + this.$props.additionalGainTechnicalEfficiency;
    },
  },
};
</script>

<style lang="scss">
.backbeat-table {
  table.b-table > thead th {
    font-size: 1.2rem;
    border-top: none !important;
  }
  table.b-table > tbody {
    font-size: 1.2rem;
  }
}
</style>

<style lang="scss" scoped>
.eficiencia-tecnica {
  border-radius: 10px;
  background-color: #ffffff;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  width: 100%;
}
.span-card {
  width: 100%;
  height: 0.05rem;
  border-radius: 20%;
  background-color: var(--grey-3);
}
.custon-pointer {
  cursor: pointer;
}
.custon-grid {
  padding-bottom: 2rem;
}
.dark-0 {
  color: var(--dark-0);
}
.p-16-custom {
  font-size: multiplier-default-font-size(3); // 16
}
.primary {
  color: var(--primary);
}
.img-learn-more {
  height: 2rem;
  width: 2rem;
}
.custom-pointer {
  cursor: pointer;
}
.eficiencia-tecnica-footer {
  width: 100%;
  display: grid;
  grid-template-columns: auto 115px;
}
.custom-align-footer {
  display: flex;
  justify-content: left;
  align-items: flex-end;
  align-content: flex-end;
}

.custom-align-footer p {
  display: flex;
}

.custom-align {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.custom-icon-check {
  background-image: url("../../../../assets/images/icon-check.svg");
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
}
.custom-icon-no-check {
  background-image: url("../../../../assets/images/icon-error.svg");
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
}
.img-learn-more {
  height: 2rem;
  width: 2rem;
}
@media (max-width: 363px) {
  .eficiencia-tecnica-footer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
}
</style>